<template>
  <div class="vl-home">
    <!-- 地图区域开始 -->
    <div class="banner"></div>
    <!-- 地图趋于结束 -->

    <!-- 内容区域开始 -->
    <div style="display: block; width: 100%">
      <div class="look-more">
        <div class="contain overHidden" style="display: flex">
          <div class="float-left title-style">
            <p>什么是开放平台？</p>
            <div>
              开放平台是以“开放”为核心思想，以“合作共赢”为建设理念的服务平台，其主要目
              的是为广大应用提供商提供一站式、规范的、标准化的开放能力服务。
            </div>
          </div>
          <div class="float-left title-style">
            <p>应用接入规范</p>
            <div>
              应用的完整名称。应用名称需要具有一定概括性，使用户通过应用名称可大致了解该应
              用的性质、面向对象等要素。应用名称长度在4~8个中文汉字范围内为最佳展现效果...
            </div>
          </div>
          <div class="float-left">
            <a href="javascript:void(0);" @click="goDoc(1)" class="more"
              >查看更多</a
            >
          </div>
        </div>
      </div>
      <!--        平台精品应用-->
<!--      <div class="platform-apply-box">-->
<!--        <div class="contain" style="height: 458px">-->
<!--          <p class="platform-title">平台热门应用</p>-->
<!--          <ul class="platform-ul overHidden" style="display: flex">-->
<!--            <li-->
<!--              class="platform-li float-left"-->
<!--              v-for="(item, index) in appList"-->
<!--              :key="index"-->
<!--            >-->
<!--              <div>-->
<!--                <img :src="item.appLogo" alt="" />-->
<!--              </div>-->
<!--              <p>{{ item.appName }}</p>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </div>-->
<!--      </div>-->
      <!--       应用接入平台-->
      <div class="application-platform">
        <div class="contain" style="height: 500px; position: relative">
          <p class="application-title">应用接入流程</p>
          <ul class="overHidden application-ul" style="display: flex">
            <li class="application-li float-left position-r">
              <img src="../../../../assets/img/home/register.png" alt="" />
              <p class="title-des">①登记应用信息</p>
              <p class="application-des">填写应用相关信息，进行应用登记</p>
              <em class="display-line position-a"></em>
            </li>
            <li class="application-li float-left position-r">
              <img
                src="../../../../assets/img/home/getAuthorization.png"
                alt=""
              />
              <p class="title-des">②获得授权</p>
              <p class="application-des">对申请接入的应用进行审批，给予授权</p>
              <em class="display-line position-a"></em>
            </li>
            <li class="application-li float-left position-r">
              <img src="../../../../assets/img/home/development.png" alt="" />
              <p class="title-des">③接口开发和调试</p>
              <p class="application-des">
                服务企业获得授权后，可订阅平台接口以及接口调试
              </p>
              <em class="display-line position-a"></em>
            </li>
            <li class="application-li float-left position-r">
              <img src="../../../../assets/img/home/goOnline.png" alt="" />
              <p class="title-des">④申请上线</p>
              <p class="application-des">服务企业申请将应用上线至应用中心</p>
            </li>
          </ul>
          <div class="baseMap">
            <img src="../../../../assets/img/home/baseMapLeft.png" alt="" />
            <img src="../../../../assets/img/home/baseMapRight.png" alt="" />
          </div>
        </div>
      </div>
      <!--        我们能提供-->
      <div class="we-apply">
        <div class="contain">
          <p class="we-apply-title">我们能提供</p>
          <ul class="overHidden apply-ul">
            <li class="float-left apply-li flip-container">
              <a href="#" class="flipper">
                <div class="front">
                  <p>认证</p>
                </div>
                <div class="back">
                  <p>认证</p>
                  <div>
                    平台提供高效、便捷、高安全的统一认证方式，实现单点登陆、单点退出
                  </div>
                </div>
              </a>
            </li>
            <li class="float-left apply-li flip-data">
              <a href="#" class="flipper">
                <div class="front">
                  <p>数据</p>
                </div>
                <div class="back">
                  <p>数据</p>
                  <div>
                    提供统一的数据标准及业务数据通道，拉通业务数据，实现各类过程性业务数据的汇聚
                  </div>
                </div>
              </a>
            </li>
            <li class="float-left apply-li flip-resources">
              <a href="#" class="flipper">
                <div class="front">
                  <p>资源</p>
                </div>
                <div class="back">
                  <p>资源</p>
                  <div>
                    平台提供海量资源，教育云资源、国家教育资源、第三方资源，实现优质教学资源共建共享
                  </div>
                </div>
              </a>
            </li>
            <li class="float-left apply-li flip-AIability">
              <a href="#" class="flipper">
                <div class="front">
                  <p>AI能力</p>
                </div>
                <div class="back">
                  <p>AI能力</p>
                  <div>
                    平台提供人脸识别,OCR文字识别能力等AI能力，为教育信息化提供人工智能服务
                  </div>
                </div>
              </a>
            </li>
            <li class="float-left apply-li flip-blockchain">
              <a href="#" class="flipper">
                <div class="front">
                  <p>区块链</p>
                </div>
                <div class="back">
                  <p>区块链</p>
                  <div>
                    基于区块链不可篡改、分布式储存、可追溯的特性，提高安全性的同时保证认证效率
                  </div>
                </div>
              </a>
            </li>
            <li class="float-left apply-li flip-transcoding">
              <a href="#" class="flipper">
                <div class="front">
                  <p>转码服务</p>
                </div>
                <div class="back">
                  <p>转码服务</p>
                  <div>
                    对非结构化数据资源进行转码处理，满足多终端应用的需求
                  </div>
                </div>
              </a>
            </li>
            <li class="float-left apply-li flip-bunch">
              <a href="#" class="flipper">
                <div class="front">
                  <p>点播服务</p>
                </div>
                <div class="back">
                  <p>点播服务</p>
                  <div>可快速实现互通资源的解析和本地化无插件化预览与点播</div>
                </div>
              </a>
            </li>
            <li class="float-left apply-li flip-advices">
              <a href="#" class="flipper">
                <div class="front">
                  <p>消息推送</p>
                </div>
                <div class="back">
                  <p>消息推送</p>
                  <div>可为平台用户提供稳定、可靠、高效的消息推送服务</div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 内容区域结束 -->
  </div>
</template>
<script>
import {
  HomeGetAppInfoList,
  HomeGetIndexDocInfo,
} from "../../api/home/api.home";

export default {
  data() {
    return {
      appList: [],
      idObj: {},
    };
  },
  mounted() {
    this.$_setTitle('首页-开放平台');

    this.getAppList();
    this.getIndexDocInfo();
  },
  methods: {
    // 跳转文档页面
    goDoc(id) {
      if (id == 1) {
        this.$router.push({
          name: "basicDoc",
          query: { docId: this.idObj.baseDocId },
        });
      }
    },
    // 获取不同的docId
    getIndexDocInfo() {
      HomeGetIndexDocInfo().then(
        (success) => {
          if (success.code == "00000") {
            this.idObj = success.result;
          } else {
            this.idObj = {};
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    /**
     * 应用列表
     * */
    getAppList() {
      // HomeGetAppInfoList().then((res) => {
      //   if (res && res.result) {
      //     this.appList = res.result;
      //   }
      // });
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.vl-home {
  .banner {
    height: 520px;
    width: 100%;
    position: relative;
    overflow: hidden;
    background: url(../../../../assets/img/home/Banner.png) no-repeat center;
  }
  .look-more {
    height: 100px;
    background: #fff;
  }
  .contain {
    width: 1230px;
    margin: 0 auto;
  }
  .top {
    height: 76px;
    width: 100%;
    background: #000;
    line-height: 76px;
  }

  .float-left {
    float: left;
  }

  .float-right {
    float: right;
  }

  .float-left span.nx-platform {
    color: #fff;
    font-size: 24px;
    font-family: "AlibabaPuHuiTiR";
    margin-right: 84px;
  }

  .float-left a.active {
    border-bottom: 4px solid #4286f5;
    color: #fff;
    font-weight: 500;
  }

  .float-left .href-style:hover {
    border-bottom: 4px solid #4286f5;
    color: #fff;
    font-weight: 500;
  }

  .float-left .href-style {
    display: inline-block;
    text-decoration: none;
    height: 55px;
    color: #999999;
    margin-right: 55px;
  }

  .float-right .login {
    display: inline-block;
    color: #fff;
    text-decoration: none;
    width: 76px;
    height: 36px;
    background: #4286f5;
    border-radius: 18px;
    text-align: center;
    line-height: 36px;
    margin-top: 20px;
  }

  .overHidden {
    overflow: hidden;
  }

  .title-style {
    flex: 2;
    cursor: pointer;
    border-left: 1px solid #e8e8e8;
    /* width: 482px; */
    padding: 0 30px;
    height: 100px;
  }
  .title-style > div {
    /* width: 456px; */
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    margin-top: 13px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .title-style > p {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    margin-top: 18px;
  }

  .more {
    flex: 1;
    display: inline-block;
    /* width: 160px; */
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4286f5;
    height: 100px;
    line-height: 100px;
    border-left: 1px solid #e8e8e8;
    border-right: 1px solid #e8e8e8;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
    padding: 0 50px;
  }
  .platform-apply-box {
    height: 458px;
    background: #f3f6fc;
  }

  .platform-title {
    // height: 50px;
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #000000;
    line-height: 50px;
    padding-top: 80px;
    text-align: center;
    background: url(../../../../assets/img/home/hotApp.png) no-repeat center
      bottom;
  }

  .platform-li {
    flex: 1;
    height: 170px;
    background: #ffffff;
    margin-right: 24px;
    margin-top: 60px;
  }

  .platform-li img {
    width: 72px;
    height: 72px;
  }
  .platform-li:last-child {
    margin-right: 0;
  }

  .platform-li p {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    margin-top: 20px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 10px;
  }
  .platform-li div {
    width: 72px;
    margin: 0 auto;
    padding-top: 28px;
  }
  .platform-li:hover {
    margin-top: 50px;
  }
  .application-platform {
    width: 100%;
    height: 500px;
    background: #ffffff;
  }

  .application-platform .application-title {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #000000;
    text-align: center;
    padding: 80px 0 69px;
    background: url(../../../../assets/img/home/cutIn.png) no-repeat center;
  }
  .application-platform .baseMap > img {
    position: absolute;
    bottom: 0;
  }
  .application-platform .baseMap > img:first-child {
    left: 50px;
  }
  .application-platform .baseMap > img:last-child {
    right: 80px;
  }

  .position-r {
    position: relative;
  }

  .position-a {
    position: absolute;
  }

  .display-inline {
    display: inline-block;
  }

  .application-platform .application-li img {
    width: 118px;
    height: 114px;
    border-radius: 50%;
    display: inline;
  }

  .application-platform .application-li {
    /* width: 240px; */
    flex: 1;
    text-align: center;
    margin-right: 78px;
  }

  .application-platform .application-li:last-child {
    margin-right: 0;
  }

  .application-platform .application-li .application-des {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
    width: 205px;
    text-align: center;
    margin: 0 auto;
  }

  .title-des {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    margin-top: 26px;
    margin-bottom: 13px;
  }

  .display-line {
    width: 170px;
    border-top: 2px dashed #d3eaff;
    top: 30%;
    left: 80%;
  }

  .we-apply {
    width: 100%;
    height: 793px;
    background: url(../../../../assets/img/home/furnish.png) no-repeat center
      bottom;
    background-size: 100% 100%;
  }

  .we-apply-title {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    padding: 50px 0 40px;
  }

  .apply-li {
    width: 300px;
    height: 285px;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .apply-li:nth-child(4),
  .apply-li:last-child {
    margin-right: 0;
  }

  .apply-li {
    display: inline-block;
    perspective: 800px;
    /*perspective属性定义3D元素距视图的距离,以像素计。该属性允许您改变 3D 元素查看 3D 元素的视图。*/
    -webkit-perspective: 800px;
    -moz-perspective: 800px;
    -ms-perspective: 800px;
    -o-perspective: 800px;
    box-sizing: border-box;
  }

  .flip-container {
    perspective: 1000;
    -webkit-perspective: 1000px;
    /*父类容器中  perspective  子类允许透视*/
    -moz-perspective: 1000px;
    -ms-perspective: 1000px;
    -o-perspective: 1000px;
    perspective: 1000px;
    .front {
      width: 100%;
      height: 100%;
      background: url(../../../../assets/img/home/attestation.png) no-repeat
        center;
      background-size: 100% 100%;
    }
    &:hover {
      .flipper {
        transform: rotateY(180deg);
      }
    }
  }

  .flip-data {
    perspective: 1000;
    -webkit-perspective: 1000px;
    /*父类容器中  perspective  子类允许透视*/
    -moz-perspective: 1000px;
    -ms-perspective: 1000px;
    -o-perspective: 1000px;
    perspective: 1000px;
    .front {
      width: 100%;
      height: 100%;
      background: url(../../../../assets/img/home/data.png) no-repeat center;
      background-size: 100% 100%;
    }
    &:hover {
      .flipper {
        transform: rotateY(180deg);
      }
    }
  }

  .flip-resources {
    perspective: 1000;
    -webkit-perspective: 1000px;
    /*父类容器中  perspective  子类允许透视*/
    -moz-perspective: 1000px;
    -ms-perspective: 1000px;
    -o-perspective: 1000px;
    perspective: 1000px;
    .front {
      width: 100%;
      height: 100%;
      background: url(../../../../assets/img/home/resources.png) no-repeat
        center;
      background-size: 100% 100%;
    }
    &:hover {
      .flipper {
        transform: rotateY(180deg);
      }
    }
  }

  .flip-AIability {
    perspective: 1000;
    -webkit-perspective: 1000px;
    /*父类容器中  perspective  子类允许透视*/
    -moz-perspective: 1000px;
    -ms-perspective: 1000px;
    -o-perspective: 1000px;
    perspective: 1000px;
    .front {
      width: 100%;
      height: 100%;
      background: url(../../../../assets/img/home/AIability.png) no-repeat
        center;
      background-size: 100% 100%;
    }
    &:hover {
      .flipper {
        transform: rotateY(180deg);
      }
    }
  }

  .flip-blockchain {
    perspective: 1000;
    -webkit-perspective: 1000px;
    /*父类容器中  perspective  子类允许透视*/
    -moz-perspective: 1000px;
    -ms-perspective: 1000px;
    -o-perspective: 1000px;
    perspective: 1000px;
    .front {
      width: 100%;
      height: 100%;
      background: url(../../../../assets/img/home/blockchain.png) no-repeat
        center;
      background-size: 100% 100%;
    }
    &:hover {
      .flipper {
        transform: rotateY(180deg);
      }
    }
  }

  .flip-transcoding {
    perspective: 1000;
    -webkit-perspective: 1000px;
    /*父类容器中  perspective  子类允许透视*/
    -moz-perspective: 1000px;
    -ms-perspective: 1000px;
    -o-perspective: 1000px;
    perspective: 1000px;
    .front {
      width: 100%;
      height: 100%;
      background: url(../../../../assets/img/home/transcoding.png) no-repeat
        center;
      background-size: 100% 100%;
    }
    &:hover {
      .flipper {
        transform: rotateY(180deg);
      }
    }
  }

  .flip-bunch {
    perspective: 1000;
    -webkit-perspective: 1000px;
    /*父类容器中  perspective  子类允许透视*/
    -moz-perspective: 1000px;
    -ms-perspective: 1000px;
    -o-perspective: 1000px;
    perspective: 1000px;
    .front {
      width: 100%;
      height: 100%;
      background: url(../../../../assets/img/home/bunch.png) no-repeat
        center;
      background-size: 100% 100%;
    }
    &:hover {
      .flipper {
        transform: rotateY(180deg);
      }
    }
  }

  .flip-advices {
    perspective: 1000;
    -webkit-perspective: 1000px;
    /*父类容器中  perspective  子类允许透视*/
    -moz-perspective: 1000px;
    -ms-perspective: 1000px;
    -o-perspective: 1000px;
    perspective: 1000px;
    .front {
      width: 100%;
      height: 100%;
      background: url(../../../../assets/img/home/advices.png) no-repeat
        center;
      background-size: 100% 100%;
    }
    &:hover {
      .flipper {
        transform: rotateY(180deg);
      }
    }
  }

  .back {
    width: 300px;
    height: 285px;
  }

  .flipper {
    transition: transform 0.6s ease-out;
    transition: transform 0.5s ease-in-out;
    -webkit-transition: transform 0.5s ease-in-out;
    -moz-transition: transform 0.5s ease-in-out;
    -ms-transition: transform 0.5s ease-in-out;
    -o-transition: transform 0.5s ease-in-out;
    -webkit-transform-style: preserve-3d;
    /*使其子类变换后得以保留 3d转换后的位置*/
    -moz-transform-style: preserve-3d;
    -ms-transform-style: preserve-3d;
    -o-transform-style: preserve-3d;
    transform-style: preserve-3d;
    display: block;
    position: relative;
    height: 100%;
    width: 100%;
  }

  .front,
  .back {
    backface-visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
  }

  .front img,
  .back img {
    width: 50px;
    height: 37px;
    overflow: hidden;
  }

  .front {
    z-index: 2;
  }

  .back {
    z-index: 1;
    transform: rotateY(180deg);
    transform: rotateY(180deg);
    -webkit-transform: rotateY(180deg);
    -moz-transform: rotateY(180deg);
    -ms-transform: rotateY(180deg);
    -o-transform: rotateY(180deg);
  }

  .front {
    padding-left: 20px;
    padding-top: 95px;
  }

  .front p {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0a4279;
  }

  .back {
    background: #399fff;
  }

  .back p {
    padding: 50px 25px 33px;
    color: #f5f8ff;
    font-size: 18px;
  }

  .back div {
    padding: 0 25px;
    color: #f5f8ff;
    font-size: 16px;
  }
}
</style>